<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
    	<v-card-title primary-title>
    	  Actividades
    	</v-card-title>
    	<v-card-text class="black--text">

    		<v-row v-if="[334,1,568,1932,1312].includes( getdatosUsuarioERPERP.iderp )">
          <v-col cols="12" lg="4" md="6">
            <label>Elige escuela</label>
            <v-radio-group v-model="escuela" row>
              <v-radio label="INBI" :value="1"></v-radio>
              <v-radio label="FAST" :value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

	      <v-row dense>
          <v-col cols="12">
          	<v-card height="600">
		        	<v-card-title primary-title>
			          <v-spacer></v-spacer>
			          <v-btn
			            color="blue-grey"
			            class="ma-2 white--text"
			            @click="downloadImage(`https://escuelakpi.club/imagenes-promociones/${url}`)"
			          >
			            Descargar
			            <v-icon
			              right
			              dark
			            >
			              mdi-cloud-download
			            </v-icon>
			          </v-btn>
			        </v-card-title>
			        <v-card-text>
		            <embed 
			            :src="`https://escuelakpi.club/viewer/web/viewer.html?file=https://escuelakpi.club/imagenes-promociones/${url}`" 
			            width="100%" 
			            :height="tamanioPantalla" 
			          />
			        </v-card-text>
          	</v-card>

          </v-col>

        </v-row>
    	</v-card-text>
    </v-card>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
	import axios from 'axios';

  import { mapGetters, mapActions }    from "vuex";

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import SemanaUno             from '@/components/SemanaUno.vue';
  import SemanaDos             from '@/components/SemanaDos.vue';
  import SemanaTres             from '@/components/SemanaTres.vue';
  import SemanaCuatro             from '@/components/SemanaCuatro.vue';

  export default {

  	components:{
      Alerta,
      carga,
      SemanaUno,
      SemanaDos,
      SemanaTres,
      SemanaCuatro,
    },

    mixins: [ validarErrores ],

    data: () => ({

    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

    	edad: null,
    	modalidad: null,
    	horario: null,
    	hermanos: null,

    	promociones: [],
    	semana: null,

      escuela: null,


    }),

    created( ){

    },

    methods:{


    },

    computed:{
      ...mapGetters('login',['getEscuela','getdatosUsuarioERPERP']),

    	url( ){

    		let archivo = this.escuela == 1 ? 'actividades_2026_recepcion_inbi.pdf' : this.getEscuela == 1 ?  'actividades_2026_recepcion_inbi.pdf': 'actividades_2026_recepcion_fast.pdf'

        return archivo

    	},

      tamanioPantalla () {
        return this.$vuetify.breakpoint.height -185
    	},
    }
  }
</script>

<style>
  body {
  margin: 0;
  font-family: sans-serif;
  font-size: 0.9rem;
}
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
#toolbar {
  display: flex;
  align-items: center;
  background-color: #555;
  color: #fff;
  padding: 0.5em;
}
#toolbar button,
#page-mode input {
  color: currentColor;
  background-color: transparent;
  font: inherit;
  border: 1px solid currentColor;
  border-radius: 3px;
  padding: 0.25em 0.5em;
}
#toolbar button:hover,
#toolbar button:focus,
#page-mode input:hover,
#page-mode input:focus {
  color: lightGreen;
}
#page-mode {
  display: flex;
  align-items: center;
  padding: 0.25em 0.5em;
}

#viewport-container {
  flex: 1;
  background: #eee;
  overflow: auto;
}


#viewport {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
#viewport > div {
  text-align: center;
  max-width: 100%;
}
#viewport canvas {
  width: 100%;
  box-shadow: 0 2px 5px gray;
}

#viewerContainer::-webkit-scrollbar {
  -webkit-appearance: none !important;
}

#viewerContainer > #viewerContainer::-webkit-scrollbar:vertical {
  width: 8px !important;
}

#viewerContainer::-webkit-scrollbar:vertical{
  width: 8px !important;
}

#viewerContainer::-webkit-scrollbar-thumb{
  background-color: #BABCBF;
  border-radius: 20px;
  border: 1px solid #ededed;
}

</style>
